import router from './router'
import store from './store'
import { Message } from 'element-ui'
import 'nprogress/nprogress.css' // progress bar style
import NProgress from 'nprogress' // progress bar

const whiteList = ['/login'] // no redirect whitelist
// 路由拦截器
router.beforeEach(async (to, from, next) => {
  // console.log('to, from, next')
  // console.log('to',to)
  // store.commit('selectMenu', to)
  // console.log(from)

  //   if (window.location.href.indexOf('code') >= 0) {
  //     let code = window.location.href.split('?')[1];
  //     code = code.substring(5, code.indexOf('&'));
  //     console.log('111',window.location.href.indexOf('code'))
  //     console.log('222', code)


  // }



  NProgress.start() //开启进度条
  if (sessionStorage.getItem('uid')) {
    // if 去的path 是登陆页
    if(to.meta&&to.meta.title){
      store.commit('selectMenu', to)
    }
   
    if (to.path === '/login') {

      // if is logged in, redirect to the home page
      next({ path: '/' }) //正常执行，到 /
      NProgress.done() //关闭进度条
    } else { //如果去的不是登陆页面

      try {
   
        await store.dispatch('getUserMenuList', sessionStorage.getItem('uid'))
        const menus = store.getters.menuList
        if(menus&&menus.length){
          if ((to.matched.length || from.path == '/login') || from.fullPath == "/") {
            next()
          } else {
            console.log(111)
            Message.error('您没有该权限')
          }
          // next()
  
          // const getUserMenu = store.getters.getmenuList
          // console.log('getmenuList', getUserMenu)
          // console.log('menus', menus)
  
         
          router.addRoutes(menus) //动态添加路由
          NProgress.done()
        }
        else{
          // Message.error('您没有该权限')
          sessionStorage.setItem('uid','')
          sessionStorage.setItem('username','')
       
          sessionStorage.setItem('userdata', {})
          store.commit('login', false)
        
          NProgress.done()
        }
      
      } catch (error) {
        console.log('error', error)
        store.commit('logout', 'false')
        // Message.error(error || 'Has Error') //弹出异常

        next(`/login?redirect=${to.path}`) //然后就执行这里 跳转到 login  redirect把从哪个页面出错的 
        NProgress.done()
      }

    }
  } else {
    /* has no token*/


    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()

    }
  }


  // if(sessionStorage.getItem('uid')){
  //     const accessRoutes = await store.dispatch('getUserMenuList',sessionStorage.getItem('uid'))
  //     console.log(accessRoutes)
  // // router.addRoutes(accessRoutes)
  // }
  // if (to.matched.length != 0) {

  //     if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
  //         console.log('1',to)

  //         if (sessionStorage.getItem("user")) { // 通过vuex state获取当前的user是否存在;

  //         // const accessRoutes = await store.dispatch('getUserMenuList',sessionStorage.getItem('uid'))
  //         //     console.log(accessRoutes)
  //         // router.addRoutes(accessRoutes)

  //             next();

  //         } else {

  //             next({
  //                 path: '/login',
  //                 query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //             })
  //         }
  //     } else {

  //         if (sessionStorage.getItem("user")) { // 判断是否登录
  //             if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
  //                 next();
  //             } else {
  //                 /**
  //                  * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页 
  //                  */
  //                 next({
  //                     path: '/index'
  //                 })
  //             }
  //         } else {
  //             next();
  //         }
  //     }
  // } else {
  //     next({
  //         path: '/login',
  //         query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //     })
  // }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})

